import reqest from "../common/reqest";

/**
 * 获取邮箱验证码
 * @returns {Promise | Promise<unknown>}
 */
export function getEmailCode(data) {
  return reqest.send("/Login/Email_Code", data)
}


/**
 * 获取手机验证码
 * @returns {Promise | Promise<unknown>}
 */
export function getTelCode(data) {
  return reqest.send("/Login/Tel_Code", data)
}

/**
 * 注册用户
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export function getRegister(data) {
  return reqest.send("/Login/Register", data, true)
}

/**
 * 账号登录
 * @param data
 * @returns {AxiosPromise}
 */
export function getLogin(data) {
  return reqest.send("/Login/Login", data)
}

/**
 * 修改密码
 * @param data
 * @returns {AxiosPromise}
 */
export function getEditPass(data) {
  return reqest.send( "/Login/Edit_Pass", data)
}

/**
 * 退出登录
* @param data
* @returns {AxiosPromise}
*/
export function logout(data) {
  return reqest.send("/Login/Out", data)
}

/**
 * 票号登录手机验证码
 * @param data
 * @returns {Promise<unknown>}
 */
export function getTelCodeNum(data) {
  return reqest.send("/Login/Tel_Code_Num", data, true);
}

/**
 * 票号登录
 * @param data
 * @returns {Promise<unknown>}
 */
export function loginNum(data) {
  return reqest.send("/Login/Login_Num", data)
}

/**
 * 获取验证码找回密码用
 * @param data
 * @returns {Promise<unknown>}
 */
export function retPwdNum(data) {
  return reqest.send("/Login/Password_Retrieval_Num", data)
}

/**
 * 找回密码
 * @param data
 * @returns {Promise<unknown>}
 */
export function retPwd(data) {
  return reqest.send("/Login/Password_Retrieval", data)
}